<template>
	<div>
		<div style="max-width: 1600px; margin: auto; position: relative">
			<div class="topjiant10">
				<div class="toptop">
					<img class="topjiant1" src="../assets/icons/we.png" alt="" srcset="" style="" />
				</div>
				<div class="topjiant12">
					<img src="../assets/shj/erweima.jpg" class="modal-image" />
				</div>
			</div>
			<div class="topjiant20">
				<div class="toptop">
					<img class="topjiant2" src="../assets/icons/phone.png" alt="" srcset="" style="" />
				</div>
				<div class="topjiant22"> 周先生<span style="color:rgb(13, 62, 96) ;"  @click="phone">13661464089</span>
				</div>
			</div>
			<img @click="scrollToTop" class="topjiant" src="../assets/shj/top.png" alt="" srcset="" />
			<!-- <div class="topjiant1">立即咨询</div> -->
		</div>
		<div class="RouterHeaderBox" :style="{background:color}" style="transition: all 2s;" @mouseover="showtab1()"
			@mouseout="showtab2()">
			<div class="box">
				<!-- 首页logo -->
				<div class="logo" @click="back('/')">
					<img src="../assets/shj/logindi.png" alt="" />
					<!-- <h1>财达期货</h1> -->
				</div>
		
				<div class="router" v-if="!language">
					<router-link to="/" exact>首页</router-link>
					<router-link ref="nav" to="/CompanyProfile"> 公司介绍 </router-link>
					<div class="dropdown">
						<!-- <button class="dropbtn">Hover me</button> -->
						<router-link to="/Newtechnology?id=96" class="dropbtn"> 核心技术与服务 </router-link>
						<div class="dropdown-content">
							<div
								style="display: flex;justify-content: center;background-color: rgba(0, 0, 0, 0);position: absolute;top:-10px;left: 50%;transform: translateX(-50%);z-index: -1;">
								<img src="../assets/icons/sin.png" alt="" class="imgsin" />
							</div>
							<div style="background-color: #fff;">
								<a @click="click1(1)">
									<img src="../assets/icons/cui.png" class="imgcui" />
									<img src="../assets/icons/cuiactive.png" class="imgcuihover" /> 催化剂</a>
							
							</div>
						</div>
					</div>
					<router-link to="/NewProductCenter"> 产品中心 </router-link>
					<router-link to="/NewsCenter"> 新闻中心 </router-link>
					<div class="dropdown">
						<!-- <button class="dropbtn">Hover me</button> -->
						<router-link to="/ContactUs"> 联系我们 </router-link>
						<div class="dropdown-content" style="margin-left: -20px;">
							<div
								style="display: flex;justify-content: center;background-color: rgba(0, 0, 0, 0);position: absolute;top:-10px;left: 50%;transform: translateX(-50%);z-index: -1;">
								<img src="../assets/icons/sin.png" alt="" class="imgsin" />
							</div>
							<div style="background-color: #fff;">
								<router-link to="/ContactUs">
									<img src="../assets/icons/ce.png" class="imgcui" />
									<img src="../assets/icons/ceactive.png" class="imgcuihover" /> 联系我们</router-link>
								<a @click="onclick">
									<img src="../assets/icons/zhaopin.png" class="imgcui" />
									<img src="../assets/icons/zhaopinactive.png" class="imgcuihover" /> 招贤纳士</a>
							</div>
						</div>
					</div>
					<div class="language" @click="ChaEng">English</div>
				</div>
				<div class="router" v-if="language">
					<router-link to="/" exact> Home Page </router-link>
					<router-link ref="nav" to="/CompanyProfile"> Company Introduction </router-link>
					<div class="dropdown">
						<router-link to="/Newtechnology?id=108" class="dropbtn"> Core Technologies And Services
						</router-link>
						<div class="dropdown-content">
							<div
								style="display: flex;justify-content: center;background-color: rgba(0, 0, 0, 0);position: absolute;top:-10px;left: 50%;transform: translateX(-50%);z-index: -1;">
								<img src="../assets/icons/sin.png" alt="" class="imgsin" />
							</div>
							<div style="background-color: #fff;">
								<a @click="click1(1)">
									<img src="../assets/icons/cui.png" class="imgcui" />
									<img src="../assets/icons/cuiactive.png" class="imgcuihover" /> Catalyzer</a>
							
							</div>
						</div>
					</div>
					<router-link to="/NewProductCenter"> Product Center </router-link>
					<router-link to="/NewsCenter"> News Center </router-link>
					<div class="dropdown">
						<router-link to="/ContactUs"> Contact Us</router-link>
						<div class="dropdown-content" style="margin-left: -30px;">
							<div
								style="display: flex;justify-content: center;background-color: rgba(0, 0, 0, 0);position: absolute;top:-10px;left: 50%;transform: translateX(-50%);z-index: -1;">
								<img src="../assets/icons/sin.png" alt="" class="imgsin" />
							</div>
							<div style="background-color: #fff;">
								<a @click="onclick">
									<img class="imgcui" />
									<img class="imgcuihover" />Attract Talents</a>
							</div>
						</div>
					</div>
					<div class="language" @click="ChaEng">中文</div>
				</div>
			
				<div class="login">
					<div class="login-img">
				
						<div class="login-box" v-if="token">
							<div style="overflow: hidden">
								<div class="login-items">
									<ul>
										<li @click="back('/PersonalCenter')">个人中心</li>
										<li @click="logout">退出登录</li>
									</ul>
								</div>
							</div>
						</div>
					</div>
				</div>
			
			</div>
		</div>
		<div class="q">
			<div class="header">
				<div class="header-img" @click="back('/')">
					<!-- <img src="@/assets/image/logo(2).png" alt="" class="SchoolLogo1" /> -->
					<img src="../assets/shj/newhlogo.jpg" alt="" srcset="" class="SchoolLogo1" />
				</div>
				<!-- 三横杠 -->
				<div class="right-img">
					<div class="header-img2">
						<!-- <img
              src="@/assets/image/login.png"
              alt=""
              class="login"
              @click="back('/Search')"
            /> -->
						<img src="@/assets/san.png" alt="" @click="drawerOpen" class="SchoolLogo2" />
					</div>
				</div>
			</div>
		</div>
		<!-- </div> -->
		<div style="z-index: 2000" v-if="true">
			<el-drawer :visible.sync="drawer" :height="drawerHeight" :direction="direction" v-if="!language">
				<div class="zhedie">
					<el-collapse v-model="activeNames" @change="handleChange">
						<div @click="drawerClose">
							<router-link to="/" exact active-class="active"> 首页 </router-link>
						</div>
						<div @click="drawerClose">
							<router-link to="/CompanyProfile" active-class="active"> 公司介绍 </router-link>
						</div>
						<el-collapse-item title="核心技术与服务">
							<div @click="drawerClose" class="catalyst">
								<router-link to="/Newtechnology?id=96" active-class="active"
									style="background-color: #oo71d3;"> 催化剂 </router-link>
							</div>
						</el-collapse-item>
						<div @click="drawerClose">
							<router-link to="/NewProductCenter" active-class="active"> 产品中心 </router-link>
						</div>
						<div @click="drawerClose">
							<router-link to="/NewsCenter" active-class="active"> 新闻中心 </router-link>
						</div>
						<el-collapse-item title="联系我们">
							<div @click="drawerClose">
								<router-link to="/ContactUs" active-class="active"> 联系我们 </router-link>
							</div>
							<div @click="drawerClose">
								<router-link to="/Hire" active-class="active"> 招贤纳士 </router-link>
							</div>
						</el-collapse-item>
						<div class="language" @click="ChaEng">English</div>
					</el-collapse>
				</div>
			</el-drawer>
			
			<el-drawer :visible.sync="drawer" :height="drawerHeight" :direction="direction" v-if="language">
				<div class="zhedie">
					<el-collapse v-model="activeNames" @change="handleChange">
						<div @click="drawerClose">
							<router-link to="/" exact active-class="active"> Home Page </router-link>
						</div>
						<div @click="drawerClose">
							<router-link to="/CompanyProfile" active-class="active"> Company Introduction </router-link>
						</div>
						<el-collapse-item title="Technologies">
							<div @click="drawerClose" class="catalyst">
								<router-link to="/Newtechnology?id=96" active-class="active"
									style="background-color: #oo71d3;"> Catalyst </router-link>
							</div>
						</el-collapse-item>
						<div @click="drawerClose">
							<router-link to="/NewProductCenter" active-class="active"> Product Center </router-link>
						</div>
						<div @click="drawerClose">
							<router-link to="/NewsCenter" active-class="active"> News Center </router-link>
						</div>
						<el-collapse-item title="Contact Us">
							<div @click="drawerClose">
								<router-link to="/ContactUs" active-class="active"> Contact Us </router-link>
							</div>
							<div @click="drawerClose">
								<router-link to="/Hire" active-class="active"> Attract Talents </router-link>
							</div>
						</el-collapse-item>
						<div class="language" @click="ChaEng">English</div>
					</el-collapse>
				</div>
			
			</el-drawer>
		</div>
		<a href="" v-show="false" ref="tels"></a>
		<div>
			<div v-if="isModalOpen" class="modal" @click.self="closeModal">
				<div class="modal-content">
					<!-- <span class="close" @click="closeModal">&times;</span> -->
					<img src="../assets/shj/erweima.jpg" class="modal-image" />
				</div>
			</div>
			<div v-if="isModalOpen1" class="modal" @click="closeModal1">
				<div class="modal-content">
					<div class="right-bottom-center">
						<div>周先生(市场)</div>
						<div style="font-weight: bold">13661464089</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	import {
		verifyLogin,
		info
	} from "@/api/user";
	import HeaderSideBar from "./HeaderSideBar.vue";
	export default {
		components: {
			HeaderSideBar
		},
		props: {
			lan: String,
			menuList: Array,
		},
		data() {
			return {
				activeNames: [],
				isModalOpen: false,
				isModalOpen1: false,
				n: 0,
				drawer: false,
				direction: "rtl",
				color: "",
				height: "",
				detail: "",
				drawerHeight: "900px",
				id: 1,
				title: "",
				child: [],
				openSearch: false,
				img: "",
				token: localStorage.getItem("token") && localStorage.getItem("token") != "undefined" ? localStorage
					.getItem("token") : "",
				name: "首页",
				language: false,
			};
		},
		watch: {
			$route(newValue, oldValue) {
				this.n = 1;
				if (this.$route.query && this.$route.query.type) {
					for (const index in this.menuList) {
						if (this.$route.query.type == this.menuList[index].id) {
							this.n = parseInt(index) + 2;
						}
					}
				}
				// console.log(this.menuList[3].children[0]);
				this.verifyLogin();
			},
		},
		// created() {
		//   router.beforeEach((to, from, next) => {
		//     if (localStorage.getItem("token")) {
		//       next();
		//     } else {
		//       this.$message({
		//         message: "请先登录",
		//         type: "error",
		//       });
		//       next({
		//         path: "/login",
		//       });
		//     }
		//   });
		// },
		mounted() {
			this.verifyLogin();
			let that = this;
			// window.onscroll = () => {
			//   let height = window.innerHeight / 3;
			//   that.color = `rgba(13, 62, 96,${
			//     document.documentElement.scrollTop / height
			//   })`;
			// };
			// console.log( document.documentElement.scrollTop)
			// this.height = (window.innerHeight * 1) / 2;
			// this.height1 = (window.innerHeight * 1) / 3;
			// window.onresize = () => {
			//   this.height = (window.innerHeight * 1) / 2;
			//   this.height1 = (window.innerHeight * 1) / 3;
			// };
			window.addEventListener("scroll", this.windowScroll);
			this.language = localStorage.getItem("language") == 'English' ? true : false;
		},
		methods: {
			phone() {
				window.location.href = 'tel:' + '13661464089'				
			},
			scrollToTopimg() {
				this.isModalOpen = true;
			},
			closeModal() {
				this.isModalOpen = false;
			},
			scrollToTopphone() {
				this.isModalOpen1 = true;
			},
			closeModal1() {
				this.isModalOpen1 = false;
			},
			ChaEng() {
				this.language = localStorage.getItem("language") == 'English' ? true : false
				console.log("取值", this.language)
				this.language = !this.language
				localStorage.setItem("language", this.language == false ? 'Chain' : 'English')
				location.reload()
			},
			windowScroll() {
				const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
				if (scrollTop >= 200 && scrollTop <= 800) {
					this.color = 'rgba(13, 62, 96, 0.8)'
				}
				if (scrollTop >= 800) {
					this.color = 'rgba(13, 62, 96, 1)'
				} else {
					this.color = 'rgba(13, 62, 96, 0.3)'
				}
			},
			onclick(e) {
				this.$router.push('/Hire')
			},
			click1(e) {
				// const all = [e,96]
				this.id = !this.language ? "96" : "108"
				this.$router.push('/Newtechnology?id=' + this.id)
				// console.log(all[1],'click1')
			},
			click2(e) {
				this.$router.push('/Newtechnology?id=145')
				console.log(e, 'click2')
			},
			click3(e) {
				console.log(e, 'click3')
				this.$router.push('/Newtechnology?id=146')
			},
			mouseenter(e) {
				e.preventDefault(); //阻止事件默认行为
				console.log(1)
			},
			scrollToTop() {
				window.scrollTo({
					top: 0,
					behavior: "smooth"
				});
			},
			routerlink(name) {
				console.log(name);
				this.name = name;
				if (name == "首页") {
					this.$router.push("/");
				}
			},
			imgUrl(e) {
				if (!e) {
					return "../assets/image/moren.png";
				} else if (e.substring(0, 4) != "http") {
					return "http://cdqy.imlimit.com" + e;
				} else {
					return e;
				}
			},
			change(data) {
				console.log(this.data);
				if (data.item.id === data.id) {
					if (this.$route.query.type !== item.id) {
						this.back("/WineCulture?type=" + item.id);
					}
				} else if (!data.item.children || data.item.children.length === 0) {
					if (!this.token && data.item.id) {
						this.back("/Login");
					} else {
						this.back("/WineCulture?type=" + data.id + "&id=" + data.item.id);
					}
				}
			},
			backChildren(menu, item, index) {
				let id = item.id;
				if (item.children && item.children.length > 0) {
					id = this.getId(item.children).id;
				}
				this.back("/WineCulture?type=" + menu.id + "&id=" + id, index);
			},
			getId(list) {
				const item = list[0];
				if (!item.children || item.children.length == 0) {
					return item;
				} else {
					return this.getId(item.children);
				}
			},
			callPhone(phoneNumber) {
				this.$refs.tels.href = `tel://` + phoneNumber;
				this.$refs.tels.click();
			},
			showtab1() {
				this.color = `rgba(13, 62, 96, 1)`;
				clearTimeout(this.timeout);
			},
			showtab2() {
				this.timeout = setTimeout(() => {
					let height = window.innerHeight / 3;
					this.color = `rgba(13, 62, 96,${
          document.documentElement.scrollTop / height
        })`;
				}, 100);
			},
			drawerOpen() {
				this.drawer = true;
			},
			drawerClose() {
				this.drawer = false;
			},
			backItem(i, id, idx) {
				this.n = idx;
				if (!this.token && id == 5) {
					this.$router.push("/Login");
				} else {
					this.$router.push(i);
				}
				this.drawer = false;
			},
			backChildrenNew(i, id, idx) {
				this.n = idx;
				if (
					(!this.token && id == 42) || (!this.token && id == 43) || (!this.token && id == 44) || (!this.token &&
						id == 45)) {
					this.$router.push("/Login");
				} else {
					this.$router.push(i);
				}
				this.drawer = false;
			},
			back(i, idx) {
				this.n = idx;
				this.$router.push(i);
				this.drawer = false;
			},
			backLogin() {
				this.$router.push("/Login");
				this.drawer = false;
			},
			openSearchBtn() {
				this.openSearch = !this.openSearch;
			},
			adjustHeight(newHeight) {
				this.drawerHeight = newHeight;
			},
			handleCurrentChange(e) {
				this.page = e;
				this.getList();
			},
			verifyLogin() {
				this.toekn = localStorage.getItem("token") && localStorage.getItem("token") != "undefined" ? localStorage
					.getItem("token") : "";
				if (this.token) {
					verifyLogin().then((res) => {
						if (res.data.code !== 0) {
							this.token = "";
							localStorage.removeItem("token");
						} else {
							info().then((res) => {
								this.img = res.data.data.avatar;
							});
						}
					});
				}
			},
			logout() {
				localStorage.removeItem("token");
				this.$store.dispatch("logout");
				this.$router.push("/Login");
				window.location.reload();
			},
		},
	};
</script>
<style scoped>
	.zhedie {}

	.zhedie>>>.el-collapse-item__header {
		background-color: #0071d3;
		color: #fff;
		font-size: 16px;
		font-weight: 400;
		display: flex;
		justify-content: center;
		align-items: center;
		border-bottom: none;
	}

	.zhedie>>>.el-collapse-item>div:first-child {
		display: flex;
		justify-content: center;
	}

	.zhedie>>>.el-collapse-item__content {
		padding-bottom: 10px;
		background-color: #0071d3;
		align-items: center;
		display: flex;
		justify-content: center;
		flex-direction: column;
		font-size: 15px;
	}

	.zhedie>>>.el-collapse-item__content>div {
		margin-bottom: 10px;
	}
</style>
<style lang="scss" scoped>
	.modal {
		position: fixed;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		background-color: rgba(0, 0, 0, 0.8);
		display: flex;
		justify-content: center;
		align-items: center;
		z-index: 1000;
	}

	.modal-content {
		position: relative;
		background-color: #fff;
		padding: 20px;
		border-radius: 8px;
	}

	.right-bottom {
		display: flex;
		align-items: center;
		color: white;
		justify-content: space-between;
		margin-top: 40px;
	}

	.right-bottom-center {
		flex: 1;
		margin-left: 16px;
		font-size: 50px;
	}

	.close {
		position: absolute;
		top: 10px;
		right: 10px;
		font-size: 24px;
		cursor: pointer;
	}

	.modal-image {
		max-width: 100%;
		height: auto;
	}

	.dropbtn {
		// padding: 16px;
		// font-size: 16px;
		// border: none;
		// cursor: pointer;
	}

	/* Container for the dropdown content (hidden by default) */
	.dropdown-content {
		visibility: hidden;
		opacity: 0;
		position: absolute;
		min-width: 112px;
		z-index: 1;
		transform: translateY(-30px);
		transition: all 0.3s ease;
		margin-top: -5px;
	}

	.imgsin {
		width: 20px;
	}

	/* Links inside the dropdown */
	.dropdown-content a {
		color: #0d3c5c !important;
		// font-size: 18px;
		text-decoration: none;
		height: 50px;
		display: block;
		display: flex;
		// justify-content: center;
		align-items: center;
		transition: all 0.3s;

		img {
			width: 20px;
			margin: 0 10px;
		}

		.imgcui {
			width: 20px;
			margin: 0 10px;
			visibility: visible;
			opacity: 1;
			transition: all 0.3s;
			position: absolute;
		}

		.imgcuihover {
			width: 20px;
			margin: 0 10px;
			opacity: 0;
			visibility: hidden;
			transition: all 0.3s;
		}
	}

	/* Change color of dropdown links on hover */
	.dropdown-content a:hover {
		background-color: #3498db;
		color: #b7c6d1 !important;
		transition: all 0.3s;

		.imgcui {
			width: 20px;
			margin: 0 10px;
			visibility: hidden;
			opacity: 0;
			transition: all 0.3s;
		}

		.imgcuihover {
			width: 20px;
			margin: 0 10px;
			opacity: 1;
			visibility: visible;
			transition: all 0.3s;
		}
	}

	/* Show the dropdown content when the mouse is over the dropdown button */
	.dropdown:hover .dropdown-content {
		opacity: 1;
		visibility: visible;
		transform: translateY(0px);
		transition: all 0.3s ease;
	}

	/* Optional: Add some styling to the dropdown button when the content is shown */
	.dropdown:hover .dropbtn {
		transition: all 0.3s;
	}

	.router {
		display: flex;
		justify-content: space-between;
		flex: 1;
		margin-left: 20%;

		.language {
			transition: all 0.3s;
			position: relative;
			color: white !important;
			text-decoration: none;
			display: block;
			cursor: pointer;
		}

		.language::before {
			content: '';
			width: 0%;
			height: 3px;
			background: #fff;
			position: absolute;
			bottom: 0px;
			left: 50%;
			transform: translateX(-50%);
			transition: all 0.3s;
		}

		.language:hover {
			&::before {
				width: 100%;
			}
		}

		&>a {
			transition: all 0.3s;
			position: relative;
		}

		&>a::before {
			content: '';
			width: 0%;
			height: 3px;
			background: #fff;
			position: absolute;
			bottom: 0px;
			left: 50%;
			transform: translateX(-50%);
			transition: all 0.3s;
		}

		&>a:hover {

			// border-bottom:2px solid #fff;
			&::before {
				width: 100%;
			}
		}
	}

	.topjiant {
		position: fixed;
		bottom: 100px;
		right: 0px;
		z-index: 999999;
	}

	.topjiant1 {
		width: 60px;
		border-radius: 50%;
		cursor: pointer;
	}

	.topjiant10 {
		display: flex;
		position: fixed;
		bottom: 210px;
		right: 20px;
		z-index: 999999;
	}

	.topjiant20 {
		display: flex;
		position: fixed;
		bottom: 300px;
		right: 20px;
		z-index: 999999;
	}

	.topjiant12 {
		width: 150px;
		height: 150px;
		position: absolute;
		right: 80px;
		top: -30px;
		display: none;
		z-index: 0;
	}

	.toptop:hover+.topjiant12 {
		display: flex;
	}

	.topjiant2 {
		width: 60px;
		border-radius: 50%;
		cursor: pointer;
	}

	.topjiant22 {
		font-size: 20px;
		overflow: hidden;
		opacity: 0;
		padding: 10px 30px;
		background-color: #ccc;
		border-radius: 50px;
		position: absolute;
		right: 80px;
		z-index: -1;
		transition: all 0.3s;
	}

	.toptop {
		width: 60px;
	}

	.toptop:hover+.topjiant22 {
		overflow: visible;
		opacity: 1;
	}

	a {
		color: white !important;
		text-decoration: none;
		display: block;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}

	.router-link-active {
		color: white;
		border-bottom: 3px solid white;

		&:hover {

			// border-bottom:2px solid #fff;
			&::before {
				width: 0% !important;
			}
		}
	}

	.active {
		color: white;
	}

	.q {
		display: none;
		position: relative;

		@media (max-width: 1200px) {
			display: block;
			height: 80px;
			// position: fixed;
			// transition: all 0.3s linear;
		}

		@media (max-width: 800px) {
			width: 100%;
			// margin: 0 auto;
			height: 60px;
		}

		.header {
			width: 100%;
			height: 80px;
			position: fixed;
			z-index: 2000;
			align-items: center;
			background-color: #fff;
			border-bottom: 1px solid #00000020;
			box-shadow: 0px 0 2px 0 rgba(0, 0, 0, 0.16);

			@media (max-width: 800px) {
				height: 60px;
			}

			.header-img {
				float: left;
				text-align: right !important;
				width: 60%;
				line-height: 80px;
				margin-left: 2%;

				@media (max-width: 800px) {
					width: 65%;
				}

				@media (max-width: 300px) {
					width: 70%;
				}

				.SchoolLogo1 {
					// width: 217px;
					height: 57px;
					float: left;
					margin-top: 12px;
					margin-left: 12px;

					@media (max-width: 800px) {
						width: 150px;
						height: auto;
					}
				}
			}

			.right-img {
				position: absolute;
				right: 0;
				top: 0;

				// float: right;
				// text-align: right;
				// width: 38%;
				// display: flex;
				@media (max-width: 800px) {
					width: 28%;
				}

				.header-img2 {
					width: 100px;
					height: 40px;
					float: right;
					margin-top: 24px;
					margin-right: 24px;

					@media (max-width: 800px) {
						margin-right: 10px;
						margin-top: 15px;
					}

					@media (max-width: 500px) {
						width: 75px;
					}

					@media (max-width: 300px) {
						width: 55px;
						margin-right: 10px;
						margin-top: 20px;
					}

					.login {
						float: left;
						width: 30px;
						height: 30px;
						background-color: #000000;
						z-index: 99999999999;

						@media (max-width: 300px) {
							width: 20px;
							height: 20px;
						}
					}

					// 三横杠
					.SchoolLogo2 {
						float: right;
						width: 35px;
						height: 35px;
						// background-color: #000000;
						z-index: 99999999999;

						@media (max-width: 300px) {
							width: 20px;
							height: 20px;
						}
					}
				}
			}
		}
	}

	.el-drawer__header {
		margin-bottom: 0px !important;
	}

	.el-drawer__close-btn {
		background-color: white !important;
	}

	.el-drawer__open .el-drawer.rtl {
		height: auto;
		width: 60% !important;
		background: #333 !important;
		color: white !important;
	}

	.el-drawer .Qtitle {
		cursor: pointer;

		@media (max-width: 300px) {
			font-size: 14px !important;
		}
	}

	.el-drawer.rtl {
		background: #333 !important;
		color: white !important;
	}

	.el-drawer__body>* {
		width: 100% !important;
		height: 500px;
		line-height: 57px;
		text-align: center;
		padding: 0 !important;
		// border-bottom: 1px solid white ;
	}

	// .el-drawer__body > * :first-child {
	//   border-top: 1px solid white !important;
	// }
	.el-menu {
		padding: 0 !important;
	}

	.el-menu i {
		display: none !important;
		/* 取消图标 */
	}

	.el-menu-item i {
		display: none !important;
		/* 取消图标 */
	}

	.RouterHeaderBox {
		width: 100%;
		height: 80px;
		background-color: rgba(13, 62, 96, 0.3);
		z-index: 2000;
		position: fixed;
		margin: 0 auto;
		left: 0;
		right: 0;
		top: 0;
		border-bottom: 1px solid #00000020;
		box-shadow: 0px 0 2px 0 rgba(0, 0, 0, 0.16);

		@media (max-width: 1600px) {
			width: 100%;
			margin: 0 auto;
			// height: ;
		}

		@media (max-width: 1366px) {
			width: 100%;
			margin: 0 auto;
			// height: ;
		}

		@media (max-width: 1200px) {
			display: none;
			// height: ;
		}

		.box {
			max-width: 1600px;
			width: 100%;
			// width: 100%;
			height: 80px;
			margin: 0 auto;
			line-height: 80px;
			// margin: 0 auto;
			display: flex;
			// justify-content: space-around;
			justify-content: space-between;

			@media (max-width: 1600px) {
				width: 98%;
				height: 80px;
				margin: 0 auto;
			}

			@media (max-width: 1366px) {
				width: 95%;
				height: 80px;
				margin: 0 auto;
			}

			@media (max-width: 1200px) {
				display: none;
			}

			.logo {
				width: 210px;
				height: 50px;
				// margin: 0 auto;
				align-self: center;
				cursor: pointer;

				img {
					height: 100%;
				}

				@media (max-width: 1200px) {
					cursor: pointer;
					display: none;
				}
			}

			.title:hover {
				.title-content {
					// font-weight: bold;
					color: rgba(65, 186, 1, 1) !important;
				}

				.title-b {
					width: 55px;
					background: rgba(65, 186, 1, 1);
				}
			}

			.title:hover .nav-box {
				// display: block;
				// transition: all 0.6s ease;
				grid-template-rows: 1fr;
				box-shadow: 0px 3px 6px 1px rgba(0, 0, 0, 0.16);
			}

			// .search:hover .search-box {
			//   // display: block;
			//   // transition: all 0.6s ease;
			//   grid-template-rows: repeat(1, 1fr);
			//   box-shadow: 0px 3px 6px 1px rgba(0, 0, 0, 0.16);
			//   // display: block;
			// }
			.activee {
				.title-content {
					color: white !important;
				}
			}

			.title:nth-child(3) .nav-box {
				transform: translateX(-5%);
			}

			.title:nth-child(4) .nav-box {
				transform: translateX(-20%);
			}

			.title:nth-child(5) .nav-box {
				transform: translateX(-40%);
			}

			.title:nth-child(8) .nav-box {
				transform: translateX(-60%);
			}

			.title:nth-child(9) .nav-box {
				transform: translateX(-80%);
			}

			.title:nth-child(10) .nav-box {
				transform: translateX(-95%);
			}

			.title {
				position: relative;
				text-align: left;
				font-style: normal;
				text-transform: none;
				margin-right: auto;
				align-self: center;
				cursor: pointer;

				@media (max-width: 1200px) {
					display: none;
				}

				.title-content {
					height: 80px;
					line-height: 80px;
					font-family: SourceHanSansCN-Regular, SourceHanSansCN-Regular !important;
					font-weight: normal;
					font-size: 16px;
					color: white;
					transition: color 0.8s !important;
				}

				.title-b {
					// 底部横杠
					width: 5px;
					height: 3px;
					transition: width, background-color 0.5s;
					// background-color: #b5002a;
					// background-color: #fff;
					position: absolute;
					top: 96%;
					transform: translateY(-50%);
					left: 50%;
					transform: translateX(-50%);
					text-align: center;

					// display: none;
					@media (max-width: 1200px) {
						width: 80%;
					}
				}

				.nav-box {
					width: 700px;
					// height: 300px;
					position: absolute;
					top: 105%;
					left: 50%;
					transform: translateX(-50%);
					z-index: 1998;
					overflow: hidden;
					background-color: #fff;
					// box-shadow: 0px 3px 6px 1px rgba(0, 0, 0, 0.16);
					transition: top 0.8s;
					display: grid;
					grid-template-rows: 0fr;
					transition: 250ms grid-template-rows ease;

					.nav-items {
						width: auto;
						margin-top: 22px;

						h5 {
							width: 150px;
							height: 24px;
							line-height: 21px;
							font-weight: Medium;
							font-size: 20px;
							font-family: Source Han Sans CN, Source Han Sans CN !important;
							color: #000000;
							padding: 0 10px;
							border-left: 5px solid #c11226;
							margin: 11px 0 11px 42px;
						}
					}

					.nav-items ul {
						min-height: 30px;
						height: auto;
						margin: 0;
						list-style-type: none;
					}

					.nav-items ul:last-child {
						margin-bottom: 20px;
						margin-right: 20px;
					}

					.nav-items li:hover {
						color: #c11226;
					}

					.nav-items li:last-child {
						margin-bottom: 20px;
					}

					.nav-items li {
						height: 24px;
						line-height: 24px;
						float: left;
						font-size: 16px;
						font-family: Source Han Sans CN, Source Han Sans CN !important;
						margin-left: 12px;
					}
				}

				.active {
					// display: block;
					width: 55px;
					background-color: white;
				}
			}

			.login {
				position: relative;

				.login-img:hover .login-box {
					grid-template-rows: 5fr;
					box-shadow: 0px 3px 6px 1px rgba(0, 0, 0, 0.16);
				}

				.login-img {
					width: 80px;
					height: 80px;
					display: flex;
					justify-content: center;
					align-items: center;

					@media (max-width: 1024px) {
						margin-left: 10px;
						margin-right: 10px;
						align-self: center;
						cursor: pointer;
					}

					.img-icon {
						width: 30px;
						height: 30px;
						border-radius: 50%;
						display: block;
						cursor: pointer;
					}

					.img-head {
						width: 30px;
						height: 30px;
						border-radius: 50%;
						display: block;
					}

					.login-box {
						width: 150px;
						position: absolute;
						top: 105%;
						left: 50%;
						transform: translateX(-50%);
						z-index: 1998;
						background-color: #f9f9f9;
						overflow: hidden;
						display: grid;
						grid-template-rows: 0fr;
						transition: 500ms grid-template-rows ease !important;
						transition: 250ms box-shadow ease;

						.login-items ul {
							width: 90%;
							margin: 10px auto;
							list-style-type: none;
							padding: 0;

							li:hover {
								background-color: #ecf5ff;
							}

							li {
								width: 100%;
								min-height: 50px;
								line-height: 50px;
								margin: 0 auto;
								text-align: center;
								background-color: #fff;
								transition: background-color 0.5s ease;
								cursor: pointer;
							}
						}
					}
				}
			}

			.search {
				margin-right: 15px;
				position: relative;

				.search-img {
					width: 40px;
					height: 80px;
					display: flex;
					justify-content: center;
					align-items: center;

					img {
						width: 19px;
						height: 19px;
						display: block;
					}
				}

				.search-box {
					width: 370px;
					min-height: 67px;
					height: 67px;
					position: absolute;
					top: 105%;
					right: -15px;
					background-color: #f9f9f9;
					box-sizing: border-box;
					border: 1px solid #f1f1f1;
					border-radius: 10px;
					transition: top 0.8s;
					background-color: #fff;
					transition: top 0.8s;

					@media (max-width: 800px) {
						width: 80%;
						max-width: 370px;
					}

					input {
						width: 66%;
						float: left;
						margin-top: 10px;
						box-sizing: border-box;
						height: 48px;
						margin-left: 11px;
						border: 1px solid #e3e8f0;
						border-radius: 10px;
					}

					.search-btn {
						width: 30%;
						float: right;
						height: 48px;
						// margin-left: 10px;
						margin-top: 10px;
						background-color: #fff;
						font-family: Microsoft YaHei, Microsoft YaHei;
						font-weight: 400;
						font-size: 18px;
						color: #a1a6bb;
						line-height: 48px;
						text-align: center;
						border-radius: 10px;
						cursor: pointer;

						@media (max-width: 500px) {
							width: 25%;
						}
					}
				}
			}
		}
	}
</style>


// WEBPACK FOOTER //
// src/components/RouterHeader.vue